const getters = {
    dicts: state => state.dict.dicts,
    deptList: state => state.dept.deptList,
    deptTree: state => state.dept.deptTree,
}
export default getters
